module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "configuration-view-wrapper profile"
  }, [_c('h1', [_vm._v("Perfil")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": "loading",
      "size": "50px"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.user.id),
      expression: "!loading && user.id"
    }]
  }, [_c('div', {
    staticClass: "picture-wrapper"
  }, [_c('div', {
    staticClass: "user-picture",
    style: ({
      backgroundImage: 'url(' + _vm.user.picture_url + ')'
    })
  }), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "picture",
      "type": "file"
    },
    on: {
      "change": _vm.fileInput
    }
  }), _c('button', {
    staticClass: "btn btn-clean",
    attrs: {
      "onclick": "jQuery('#picture').click()"
    }
  }, [_vm._v("Alterar foto")])]), _c('br'), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('timezone')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "timezone"
    }
  }, [_vm._v("Fuso horário")]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    attrs: {
      "options": _vm.timezones,
      "selected": _vm.user.timezone,
      "data-vv-name": "timezone"
    },
    model: {
      value: (_vm.user.timezone),
      callback: function($$v) {
        _vm.$set(_vm.user, "timezone", $$v)
      },
      expression: "user.timezone"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timezone')),
      expression: "errors.has('timezone')"
    }],
    key: "timezone",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('timezone')))])])], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('signature')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "signature"
    }
  }, [_vm._v("Assinatura do e-mail")]), _c('textarea', {
    attrs: {
      "id": "signature",
      "name": "signature"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('signature')),
      expression: "errors.has('signature')"
    }],
    key: "signature",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('signature')))])])], 1), _c('confirm-modal', {
    attrs: {
      "id": "atualizar-assinatura-confirmation-modal",
      "title": "Assinatura alterada",
      "message": "Deseja trocar a assinatura de todos os templates/fluxos?",
      "confirm_text": "Sim",
      "confirm_class": "btn-primary",
      "reject_text": "Não"
    },
    on: {
      "confirm-modal-confirm": function($event) {
        return _vm.update(true)
      },
      "confirm-modal-reject": function($event) {
        return _vm.update(false)
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4beef098!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/profile.vue
// module id = 1107
// module chunks = 1